import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { PackageTierType } from '~/types/packagesType';
import { getPackageTierLocations } from '~/pages/Packages/utils';

export default function PackageTiersModal({
  tiers,
}: {
  tiers: PackageTierType[];
  packageName: string | null;
}) {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();
  const locations = getPackageTierLocations(tiers);
  const isOneLocation = locations.length === 1;
  return (
    <Modal
      modalKey="packageTiersModal"
      title={t('tiersTitle')}
      Footer={
        <div className="w-full">
          <Button
            ariaLabel="close-package-areas-modal"
            size="medium"
            variant="secondary"
            className="w-full"
            onClick={() => {
              dispatch(closeModal('packageTiersModal'));
            }}
          >
            {t('done')}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-3x ">
        <p className="text-body-2 text-gray__dark_2">
          {t('tiersDescription')}{' '}
        </p>
        <div
          className={`grid w-full gap-x-2x ${
            isOneLocation ? 'grid-cols-1' : 'grid-cols-2'
          }`}
        >
          {locations?.map((location, index) => (
            <div
              key={`${location.id}-${index}`}
              className={`flex items-center gap-0.5x ${isOneLocation ? '' : 'border-b border-gray'} pb-x`}
            >
              <Icon
                name="location"
                size="24px"
                className="shrink-0 text-gray__dark_2"
              />
              <p className="text-body-2 black">{location.title}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
